import { render, staticRenderFns } from "./linkedin.vue?vue&type=template&id=fcaed62a"
import script from "./linkedin.vue?vue&type=script&lang=js"
export * from "./linkedin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports